// Hooks / Node modules / Styles
import { useLocation, matchPath } from "react-router-dom";
import { useEffect } from "react";
import { ThemeProvider } from "elseware-ui";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons
import routes from "../../data/routes";

const getScrollToTopValue = (path) => {
  const route = routes.find((route) => matchPath(route.path, path));

  return route && route.scrollToTop !== undefined ? route.scrollToTop : true;
};

function GenericLayout({ children }) {
  const location = useLocation();

  useEffect(() => {
    const enableScrollToTop = getScrollToTopValue(location.pathname);

    if (enableScrollToTop) window.scrollTo(0, 0);
  }, [location]);

  return (
    <ThemeProvider defaultTheme="dark">
      <div>{children}</div>
    </ThemeProvider>
  );
}

export default GenericLayout;
